// extracted by mini-css-extract-plugin
export default {"preview":"text-preview_preview__Xyaw+"};